import React, { useState } from 'react';
import {
    DialogTitle,
    DialogActions,
    Button,
    Dialog,
    IconButton,
    TextField,
    Typography,
    Grid,
    Autocomplete,
    Box,
} from '@mui/material';
import { Add, Close, Check, Edit } from '@mui/icons-material';

import PropTypes from 'prop-types';
import unsplash from '../api/unsplash';
import 'jspdf-autotable';

import Zoom from '@mui/material/Zoom';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const initialCategory = {
    nome: null,
    tipo: null,
    codice: null,
    cliente_id: null,
};

const DettaglioCategoria = (props) => {
    const [open, setOpen] = useState(false);
    const operation = props.Operation;
    const hideDialog = false;
    const [clienti, setClienti] = useState([]);
    const [categoria, setCategoria] = useState(initialCategory);
    const [updated, setUpdated] = useState(false);

    const handleLoadClienti = async () => {
        let response = await unsplash.get('clienti', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params: { all: 'yes' },
        });
        setClienti(response.data.data);
    };

    const handleLoadSpecificClient = async (clientId) => {
        try {
            const response = await unsplash.get(`clienti/${clientId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('Error fetching specific client:', error);
            return null;
        }
    };

    const handleClickOpen = async () => {
        if (props.Operation !== 'Nuovo') {
            let cat = props.categoria;
            setCategoria(cat);
        } else if (props.clientId) {
            await handleLoadClienti();
            // If we're creating a new category and have a clientId, set it automatically
            let selectedClient = clienti.find((c) => c.ID === props.clientId);
            // If client not found in the list, fetch it specifically
            if (!selectedClient) {
                selectedClient = await handleLoadSpecificClient(props.clientId);
            }

            if (selectedClient) {
                setCategoria({
                    ...initialCategory,
                    cliente_id: props.clientId,
                    cliente: selectedClient,
                });
                setUpdated(true);
            }
        }
        setOpen(true);
    };

    const handleClose = () => {
        setCategoria(initialCategory);
        setUpdated(false);
        setOpen(false);
    };

    const handleCategoryCreation = async () => {
        if (!updated) {
            props.setSnack({
                severity: 'warning',
                messaggio: 'Nessuna modifica alla categoria',
            });
            return;
        }
        if (operation === 'Nuovo') {
            if (categoria.cliente_id === null) {
                props.setSnack({
                    severity: 'error',
                    messaggio:
                        'Cliente Obbligatorio per la creazione della categoria',
                });
                props.setOpenSnack(true);
            } else {
                try {
                    await unsplash.post(
                        'categorieCorsi',
                        { categoria: categoria },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );
                    props.setSnack({
                        severity: 'success',
                        messaggio: 'Categoria salvata con successo',
                    });
                    props.setOpenSnack(true);
                    handleClose();
                    if (props.onSuccess) {
                        props.onSuccess();
                    }
                } catch {
                    props.setSnack({
                        severity: 'error',
                        messaggio: "Errore durante l'aggiornamento",
                    });
                    props.setOpenSnack(true);
                }
            }
        } else {
            try {
                await unsplash.put(
                    'categorieCorsi',
                    { categoria: categoria },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                props.setSnack({
                    severity: 'success',
                    messaggio: 'Categoria modificata con successo',
                });
                props.setOpenSnack(true);
                handleClose();
                if (props.onSuccess) {
                    props.onSuccess();
                }
            } catch {
                props.setSnack({
                    severity: 'error',
                    messaggio: "Errore durante l'aggiornamento",
                });
                props.setOpenSnack(true);
            }
        }
    };

    return (
        <>
            <IconButton
                style={{ display: props.Operation !== 'Edit' ? 'None' : '' }}
                aria-label="edit"
                onClick={handleClickOpen}
                id={props.id}
            >
                <Edit
                    style={{ height: '2rem', width: '2rem', color: '#2265B1' }}
                />
            </IconButton>
            <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    style={{
                        display: props.Operation === 'Edit' ? 'None' : '',
                    }}
                    id={props.id}
                    variant="contained"
                    className="ButtonMiller"
                    onClick={handleClickOpen}
                    startIcon={<Add />}
                >
                    Aggiungi
                </Button>
            </Grid>
            <Dialog
                fullWidth={true}
                open={open}
                onClose={handleClose}
                maxWidth="xl"
                style={{ display: hideDialog ? 'none' : 'block' }}
                TransitionComponent={Transition}
            >
                <DialogTitle>
                    <h4 style={{ textAlign: 'center' }}>{props.Title}</h4>
                </DialogTitle>

                <Grid container spacing={2} px={3}>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="combo-box-demo"
                            options={clienti}
                            getOptionLabel={(option) => option.RagioneSociale}
                            fullWidth
                            value={categoria.cliente}
                            onChange={(event, newValue) => {
                                let c = { ...categoria };
                                c.cliente_id = newValue ? newValue.ID : null;
                                c.cliente = newValue;
                                setCategoria(c);
                                setUpdated(true);
                            }}
                            disabled={props.clientId !== undefined} // Disable if clientId is provided
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Cliente"
                                    variant="outlined"
                                    required
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Nome Categoria"
                            value={categoria.nome}
                            onChange={(e) => {
                                let c = { ...categoria };
                                c.nome = e.target.value;
                                setCategoria(c);
                                setUpdated(true);
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Tipo"
                            value={categoria.tipo}
                            onChange={(e) => {
                                let c = { ...categoria };
                                c.tipo = e.target.value;
                                setCategoria(c);
                                setUpdated(true);
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Codice"
                            value={categoria.codice}
                            onChange={(e) => {
                                let c = { ...categoria };
                                c.codice = e.target.value;
                                setCategoria(c);
                                setUpdated(true);
                            }}
                        />
                    </Grid>

                    <DialogActions>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    mt: 2,
                                    p: 2,
                                }}
                            >
                                <Button
                                    onClick={handleClose}
                                    variant="contained"
                                    className="ButtonMiller"
                                    startIcon={<Close />}
                                >
                                    Chiudi
                                </Button>
                                <Button
                                    className="ButtonMiller"
                                    variant="contained"
                                    onClick={handleCategoryCreation}
                                    startIcon={<Check />}
                                >
                                    Salva
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Grid>
            </Dialog>
        </>
    );
};

export default DettaglioCategoria;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
